module.exports = __webpack_public_path__ + "4c3f59f88b9100cff72878dd104cef0d.svg";